import { render, staticRenderFns } from "./TipAmountItem.vue?vue&type=template&id=5d99b230&scoped=true&"
import script from "./TipAmountItem.vue?vue&type=script&lang=js&"
export * from "./TipAmountItem.vue?vue&type=script&lang=js&"
import style0 from "./TipAmountItem.vue?vue&type=style&index=0&id=5d99b230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99b230",
  null
  
)

export default component.exports